import { Box } from "@mantine/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "config/redux";

import { Button, Modal, Text } from "components";
import { ServiceConstants } from "constant";import { ControlService } from "services";
import { AppUtils } from "utils";;

const { REQUEST_PENDING, REQUEST_CONTROL_F2 } = ServiceConstants;

const title = "F2: Isprazni bazu";

const F2TruncateDatabase = () => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CONTROL_F2]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);
  const submit = useCallback(() => ControlService.truncateDatabase(), []);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_CONTROL_F2, () => setModalVisible(false));
  }, [serviceObject]);
  return (
    <>
      <Button variant={'subtle'} onClick={() => setModalVisible(true)}>{title}</Button>
      <Modal opened={modalVisible} onClose={() => !isLoading ? setModalVisible(false) : {}} title={title} style={{ overflowY: 'auto' }}>
        <Text>Da li ste sigurni?</Text>
        <Box mt={40}>
          <Button
            fullWidth={true}
            disabled={isLoading}
            loading={isLoading}
            onClick={submit}
          >
            {'Potvrdi'}
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default F2TruncateDatabase;